export default __webpack_public_path__ + "static/media/evolution.0098859d.png";